
export default {
  props: {
    homeUrl: {
      type: String,
      required: true,
    },
  },
}
